<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>Dashboard
        <small>YBM LMS Admin dashboard</small>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="row">
          <div class="col-xl">
            <div class="card card-default">
              <div class="card-header">
                <div class="card-title">회원현황</div>
              </div>
              <div class="list-group">
                <div class="list-group-item">
                  <div class="media">
                    <div class="media-body text-truncate">
                      <p class="mb-1">
                        <a class="text-purple m-0" href="/mem/memberList">총 회원수</a>
                      </p>
                    </div>
                    <div class="ml-auto">
                      <small class="text-muted ml-2" v-text="data.total"></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl">
            <div class="card card-default">
              <div class="card-header">
                <div class="card-title">1:1 미답변 건수</div>
              </div>
              <div class="list-group">
                <div class="list-group-item">
                  <div class="media">
                    <div class="media-body text-truncate">
                      <p class="mb-1">
                        <a class="text-purple m-0" href="/notice/PersonalList">1:1 미답변 건수</a>
                      </p>
                    </div>
                    <div class="ml-auto">
                      <small class="text-muted ml-2" v-text="data.n_no_answer"></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl">
            <div class="card card-default">
              <div class="card-header">
                <div class="card-title">서류 인증 요청</div>
              </div>
              <div class="list-group">
                <div class="list-group-item">
                  <div class="media">
                    <div class="media-body text-truncate">
                      <p class="mb-1">
                        <a class="text-purple m-0" href="javascript:void(0);">서류 인증 요청</a>
                      </p>
                    </div>
                    <div class="ml-auto">
                      <small class="text-muted ml-2" v-text="data.n_wait_reg"></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="card card-default">
          <div class="card-header">
            <div class="card-title">회원현황</div>
          </div>
          <div class="list-group">
            <div class="list-group-item">
              <div class="media">
                <div class="align-self-start mr-2">
                  <span class="fa-stack">
                    <em class="fa fa-circle fa-stack-2x text-purple"></em>
                    <em class="fas fa-cloud-upload-alt fa-stack-1x fa-inverse text-white"></em>
                  </span>
                </div>
                <div class="media-body text-truncate">
                  <p class="mb-1">
                    <a class="text-purple m-0" href="javascript:void(0);">선생님</a>
                  </p>
                </div>
                <div class="ml-auto">
                  <small class="text-muted ml-2" v-text="data.n_teacher"></small>
                </div>
              </div>
            </div>
            <div class="list-group-item">
              <div class="media">
                <div class="align-self-start mr-2">
                  <span class="fa-stack">
                    <em class="fa fa-circle fa-stack-2x text-info"></em>
                    <em class="far fa-file-alt fa-stack-1x fa-inverse text-white"></em>
                  </span>
                </div>
                <div class="media-body text-truncate">
                  <p class="mb-1">
                    <a class="text-info m-0" href="javascript:void(0);">학생</a>
                  </p>
                </div>
                <div class="ml-auto">
                  <small class="text-muted ml-2" v-text="data.n_student"></small>
                </div>
              </div>
            </div>
            <div class="list-group-item">
              <div class="media">
                <div class="align-self-start mr-2">
                  <span class="fa-stack">
                    <em class="fa fa-circle fa-stack-2x text-danger"></em>
                    <em class="fa fa-exclamation fa-stack-1x fa-inverse text-white"></em>
                  </span>
                </div>
                <div class="media-body text-truncate">
                  <p class="mb-1">
                    <a class="text-danger m-0" href="javascript:void(0);">강사</a>
                  </p>
                </div>
                <div class="ml-auto">
                  <small class="text-muted ml-2" v-text="data.n_tutor"></small>
                </div>
              </div>
            </div>
            <div class="list-group-item">
              <div class="media">
                <div class="align-self-start mr-2">
                  <span class="fa-stack">
                    <em class="fa fa-circle fa-stack-2x text-success"></em>
                    <em class="far fa-clock fa-stack-1x fa-inverse text-white"></em>
                  </span>
                </div>
                <div class="media-body text-truncate">
                  <p class="mb-1">
                    <a class="text-success m-0" href="javascript:void(0);">학부모</a>
                  </p>
                </div>
                <div class="ml-auto">
                  <small class="text-muted ml-2" v-text="data.n_parent"></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card card-default">
          <div class="card-header">
            <div class="card-title">게시글</div>
          </div>
          <div class="list-group">
            <div v-for="(item) in data.noticeList" class="list-group-item list-group-item-action">
              <div class="media">
                  <div class="media-body text-truncate">
                    <p class="mb-1">
                      <strong class="text-primary">
                        <span class="circle bg-success circle-lg text-left"></span>
                        <span>{{item.type}} {{item.title}}</span>
                      </strong>
                    </p>
                    <p class="mb-1 text-sm">{{item.content}}</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>
<script>
import {reactive,onMounted} from "@vue/composition-api";
import {getDashboard} from "@/api/dashboard/DashboardAPI";

export default {
  setup(props) {
    const _data = {
      total: 0,
      n_teacher: 0,
      n_tutor: 0,
      n_parent: 0,
      n_student: 0,
      n_no_answer: 0,
      n_wait_reg: 0,
      noticeList: [],
    }
    const data = reactive(_data);
    const retVals = {
      data,
      ...methods(),
    }
    onMounted(async() => {
      await retVals.search();
    })
    return retVals;
  }
}
function methods() {
  async function search() {
    const result = await getDashboard();
    this.data.total = result.data.total;
    this.data.n_teacher = result.data.nteacher;
    this.data.n_tutor = result.data.ntutor;
    this.data.n_parent = result.data.nparent;
    this.data.n_student = result.data.nstudent;
    this.data.n_no_answer = result.data.nnoAnswer;
    this.data.n_wait_reg = result.data.nwaitReg;
    this.data.noticeList = result.data.noticeList;
    this.data.noticeList.forEach(element => {
      if (element.boardCatName==='notice') {
        if (!element.title.includes('[공지]')) element.type = '[공지]';
      } else {
        if (!element.title.includes('[문의]')) element.type = '[문의]';
      }
      element.content = element.content.replace(/<[^>]*>?/g, '');
    });
  }
  return {search};
}
</script>